import React, { useState, useEffect } from "react";
import { Table } from "reactstrap";
import { getSecrets, deleteSecret } from "../../Redux/actions/vault";
import CustomModal from "../../UtilityComponents/customModal";
import EmptyScreen from "../../Assets/Empty-Screen.png";
import loader from "../../Assets/loaderTransaparent.gif";
import stringToDate from "../../Utilities/stringToDate";
import CreateVault from "./CreateVault.js";
import DeleteSecretData from "./DeleteSecretData"
import { addNotification } from "../../Utilities/notifications";
import "./index.css";
import {connect} from 'react-redux'

function Vault(props) {
    let { user } = props;
    const [loading, setLoading] = useState(false);
    const [secrets, setSecrets] = useState([]);
    const [modal, setModal] = useState(false);
    const [ deleteSecretData,setDeleteSecret] = useState(false)
    const [secret, setActiveSecret] = useState(null)
    const [search_data,setsearch_data] = useState()
  
    const toggle = () => setModal(!modal);
    const secretSuccess = async () => {
        toggle()
        setLoading(true);
        let data = await getSecrets();
        setLoading(false);
        if (data && data.length > 0) {
            setSecrets(data);
        }
    }
    
    const deleteModalToggle = async(obj)=>{
        if(obj)
            setActiveSecret(obj)
        setDeleteSecret(!deleteSecretData)
    }

    const handleChange = (e) =>{    
        setsearch_data(e.target.value)
        if(e.target.value.length === 0){
          setsearch_data(null)
          fetchData()
        }
      }
      
      const fetchData = async () => {    
        setLoading(true);
        let data = await getSecrets();
        setLoading(false);
        if (data.length > 0) {
            setSecrets(data);
        }
      };
      
      const handleSearch = async () =>{
        if(search_data){
            let org = secrets.find((obj) => obj.name.toString() === search_data);      
            if(org){
                setSecrets([org])
            }
            else{
                setSecrets([])
            }
        }else{
            let data = await getSecrets();
            if (data.length > 0) {
            setSecrets(data);
        }
        }
      }

      const keyPress = async(e) => {
        if (e.key === 'Enter' ){
          handleSearch()
        }
      }
      
    const handleDelete = async()=>{        
        setDeleteSecret(!deleteSecretData)        
        if(user.organization_id){
            if(user.role_id === 1 && user.sub === secret.created_by){
            let status = await deleteSecret(secret);
                if(status === 200){
                    addNotification({
                        title: "Techforce.ai",
                        message: "Secret Asset has been deleted successfully",
                        type: "success"
                    });
                    // setDelete(false);
                    setLoading(true);
                    let data = await getSecrets();
                    setLoading(false);
                    setSecrets(data);
                }
            }
            else{
                addNotification({
                    title: "Techforce.ai",
                    message: "You don't have enough permissions to delete secret",
                    type: "info"
                });
            }
        } else {        
        let status = await deleteSecret(secret);
        if(status === 200){
            addNotification({
            title: "Techforce.ai",
            message: "Secret Asset has been deleted successfully",
            type: "success"
            });
        }
        setLoading(true);
        let data = await getSecrets();
        setLoading(false);
        setSecrets(data);
    }
    }

    const compare = (a, b) => {
        var nameA=a.created_at
        var nameB=b.created_at
        if (nameA < nameB) 
         return -1;
        if (nameA > nameB)
         return 1;
        return 0; 
    };

    useEffect(() => {
        document.title = "Secret Vault | E-Manager Console | Techforce.ai";
        const fetchData = async () => {
            setLoading(true);
            let data = await getSecrets();
            setLoading(false);
            if(data && data.length > 0) {
                setSecrets(data);
            }
        };
        fetchData();
    }, []);

    if(loading){
        return(
            <div className="main-content">
                <div className="header-content">
                    <label>Secret Vault</label>
                </div>
                <div style={{ textAlign: "center", marginTop: "15%" }}>
                    <img src={loader} width="100" alt="loading"></img>
                </div>
            </div>
        )
    }
    else{        
        return(
            <div className="main-content">
                <div className="header-content">
                    <label>Secret Vault</label>
                    <i className="fa fa-search" onClick={handleSearch} style={{height:"22px",color:"#938989",position:"absolute",right:"240px",padding:"7px",marginTop:"7px"}}></i>
                    <input type="text"  name="search_data" onChange={handleChange} onKeyPress={keyPress} placeholder="Search" style={{height:"39px",backgroundColor:"#f7f7f7",position:"absolute",right:"95px"}}/>
                    <button className="btn" onClick={toggle}>Create</button>
                </div>
                
                {secrets.length ?  
                <div className="content">
                    <Table hover responsive className="responsive-table">
                        <thead >
                            <tr>
                                <th>Name</th>
                                <th>Type</th>
                                <th>Created By</th>
                                <th>Created Date</th>
                                <th></th>
                            </tr>
                        </thead>
                        <tbody className="table-body">
                            {secrets.sort(compare).map((obj, ind) => {
                                return (
                                    <tr key={ind}>
                                        <td>
                                            <div>{obj.name}</div>
                                        </td>
                                        <td>{obj.type}</td>
                                        <td>{obj.email}</td>
                                        <td>{stringToDate(obj.created_at)}</td>
                                        <td> <i  style={{color: "red",fontSize: "1.1em"}} className="fa fa-trash" onClick={() => deleteModalToggle(obj)} data-toggle="tooltip" data-placement="top" title="Delete"></i> </td>
                                    </tr>
                                )
                            })}
                        </tbody>
                    </Table>
                </div> :  secrets.length === 0 && search_data != null?
                (<div className="content">
                  <Table hover responsive className="responsive-table">
                        <thead >
                            <tr>
                                <th>Name</th>
                                <th>Type</th>
                                <th>Created By</th>
                                <th>Created Date</th>
                                <th></th>
                            </tr>
                        </thead>
                  </Table>
               </div>):
                <div className="empty-container">
                    <img src={EmptyScreen} alt="empty Screen"></img>
                    <p>You don't have any secret assets yet.</p>
                    <small>Please create a Secret Asset</small>
                </div> 
            }
            { modal ? <CustomModal comp={<CreateVault secretSuccess={()  => secretSuccess()} toggle={() => toggle()}/>} 
                        name="New Secret Asset"
                        toggle={() => toggle()}
                        modal={modal} /> : null 
            }
                {deleteSecretData?<CustomModal comp={<DeleteSecretData  deleteSecret = {()=>handleDelete()}  name={secret.name} toggle={() => deleteModalToggle()} />}
                        name={`Are you sure you want to delete Secret `}
                        toggle={()=>deleteModalToggle()}
                        modal={deleteSecretData}/>:null}
        </div>
      )
    }
}
const mapStateToProps = (state)=>({
    user:state.user
})
export default connect(mapStateToProps,null)(Vault);
